const config = {
    // backendApi: "https://dev.ssmain-mbet.com/devapi/api"
    backendApi: "https://api.kl36.bet",
    socketApi: "https://api.kl36.bet",
    defaultLogo: "https://media-3.api-sports.io/football/teams/19110.png",

}
export default config ;